import axios from "axios";

let electronAppUrl = "http://localhost:3001";

function get_axios() {
  return axios.create({
    baseURL: electronAppUrl
  });
}

export default {
  getHardwareId() {
    return get_axios().get("/hardware-id");
  },
  getResourceUsage() {
    return get_axios().get("/resource-usage");
  },
  getMacAddress() {
    return get_axios().get("/mac-address");
  },
  openCashDrawer() {
    return get_axios().get("/open-cash-drawer");
  },
  //CINEPOLIS NBO BANK CARD MACHINE - DLL CALLS
  connect_nbo() {
    return get_axios().get("/NBO/connect");
  },
  purchase_nbo() {
    return get_axios().get("/NBO/connect");
  },
  getEcrConfigFiles() {
    return get_axios().get("/ecr/getConfig");
  }
};



// WEBPACK FOOTER //
// ./src/services/ElectronAppService.js